import React, { useState, useEffect } from 'react';
import Card from '../../common/Card/Card';
import Button from '../../common/Button/Button';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import { getallUnapproved, approveUser, rejectUser } from '../../../services/accountService';
import { useToast, useConfirm } from '../../../context/ToastContext';
import styles from './ProjectScopeApproval.module.css';

const AccountApproval = () => {
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(null); // track which user action is in progress
  const toast = useToast();
  const confirm = useConfirm();

  useEffect(() => {
    fetchAccounts();
  }, []);

  const fetchAccounts = async () => {
    try {
      const data = await getallUnapproved();
      console.log(data)
      setAccounts(data || []);
    } catch (error) {
      console.error('Error fetching accounts:', error);
      setAccounts([]);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (userId) => {
    setActionLoading(userId + '-approve');
    try {
      const result = await approveUser(userId);
      toast.success(result?.message || 'Account approved successfully!');
      fetchAccounts(); // Refresh list
    } catch (error) {
      toast.error('Error: ' + (error.response?.data?.detail || error.message));
    } finally {
      setActionLoading(null);
    }
  };

  const handleReject = async (userId) => {
    const confirmed = await confirm('Are you sure you want to reject this account?', { confirmText: 'Reject', variant: 'danger' });
    if (!confirmed) return;
    setActionLoading(userId + '-reject');
    try {
      const result = await rejectUser(userId);
      toast.success(result?.message || 'Account rejected successfully.');
      fetchAccounts();
    } catch (error) {
      toast.error('Error: ' + (error.response?.data?.detail || error.message));
    } finally {
      setActionLoading(null);
    }
  };

  if (loading) {
    return <LoadingSpinner />;
  }

  const pendingAccounts = accounts || [];

  return (
    <Card title="Account Approvals">
      {pendingAccounts.length === 0 ? (
        <p className={styles.empty}>No pending account approvals</p>
      ) : (
        <div className={styles.scopesList}>
          {pendingAccounts.map(user => (
            <div key={user.id} className={styles.scopeItem}>
              <h4>{user.first_name} {user.last_name}</h4>
              <p className={styles.scopeText}>{user.email} - {user.role}</p>
              <div className={styles.actions}>
                <Button
                  size="small"
                  onClick={() => handleApprove(user.id)}
                  loading={actionLoading === user.id + '-approve'}
                  disabled={!!actionLoading}
                >
                  Approve
                </Button>
                <Button
                  size="small"
                  variant="danger"
                  onClick={() => handleReject(user.id)}
                  loading={actionLoading === user.id + '-reject'}
                  disabled={!!actionLoading}
                >
                  Reject
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Card>
  );
};

export default AccountApproval;